import assert from "assert";

export const useCopyLink = ({ url, clipboardItem }: {
  url?:           string,
  clipboardItem?: ClipboardItem
}) => {
  assert(!(url && clipboardItem), 'CopyLink: url and clipboardItem are mutually exclusive.');

  const onCopyAsync = clipboardItem ? () => navigator.clipboard.write([clipboardItem])
                               : () => Promise.resolve(navigator.clipboard.writeText(url ?? window.location.href));

  return { onCopyAsync };
}
